module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/product-images/product-02-f257bcd254d3062f30ca37b468c39923.webp";